import React from 'react';

const AdvancedToolsPathOptions = ({ user, userUsage, setPage }) => {
  const individualTools = [
    { label: 'Understand a Patent', page: 'patent-decoder' },
    { label: 'Patentability Check', page: 'patentability-check' },
    { label: 'FTO Assessment', page: 'fto-assessment' },
    { label: 'Tech Landscape', page: 'tech-landscape' },
    { label: 'Prior Art Deep Dive', page: 'prior-art-deep-dive' },
    { label: 'Competitive Intel', page: 'competitive-intel' }
  ];

  return (
    <>
      {/* TWO PATH OPTIONS */}
      <div style={{ width: '100%', marginBottom: '16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

          {/* PATH 1: Full Invention Assessment */}
          <div style={{
            background: '#f0f9ff',
            border: '2px solid #0369a1',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#0369a1', marginBottom: '8px' }}>
              Full Invention Assessment
              {user && userUsage?.invention_assessment && (
                <span style={{ fontSize: '11px', fontWeight: 'normal', color: '#64748b', marginLeft: '8px' }}>
                  {userUsage.invention_assessment.limit >= 9999 ? (
                    <span style={{ color: '#10b981' }}>Unlimited</span>
                  ) : (
                    <>({userUsage.invention_assessment.remaining} of {userUsage.invention_assessment.limit} remaining today)</>
                  )}
                </span>
              )}
            </div>
            <p style={{ fontSize: '13px', color: '#475569', marginBottom: '16px', lineHeight: '1.5' }}>
              Assess ONE invention across all 5 tools. Get a combined report with patentability, FTO risk, market landscape, prior art analysis, and competitive intelligence.
            </p>
            <button
              type="button"
              onClick={() => setPage('invention-assessment')}
              style={{
                width: '100%',
                padding: '12px 16px',
                borderRadius: '8px',
                border: 'none',
                background: '#0369a1',
                color: 'white',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '14px'
              }}
            >
              Start Assessment
            </button>
          </div>

          {/* PATH 2: Explore Individual Tools */}
          <div style={{
            background: '#fafafa',
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            padding: '20px'
          }}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
              Explore Individual Tools
              {user && userUsage?.journey_tools && (
                <span style={{ fontSize: '11px', fontWeight: 'normal', color: '#64748b', marginLeft: '8px' }}>
                  {userUsage.journey_tools.limit >= 9999 ? (
                    <span style={{ color: '#10b981' }}>Unlimited</span>
                  ) : (
                    <>({userUsage.journey_tools.remaining} of {userUsage.journey_tools.limit} remaining today)</>
                  )}
                </span>
              )}
            </div>
            <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px', lineHeight: '1.5' }}>
              Try each tool separately with different examples. Great for learning what PatTrak can do.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {individualTools.map((tool) => (
                <button
                  key={tool.page}
                  type="button"
                  onClick={() => setPage(tool.page)}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    background: 'white',
                    color: '#374151',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  {tool.label}
                </button>
              ))}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AdvancedToolsPathOptions;
